import { useEffect } from 'react'
import { addListener } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'
import { ADD_CREDIT_CARD_SUCCESS, BOOK_VISIT_ERROR, BOOK_VISIT_SUCCESS } from './NewVisitConstants'
import { getPatientCreditCards } from './NewVisitThunk'
import { apiErrorCodes } from '../../utils/constants'
import { useAdyenIsEnabled } from '../../pages/new-visit/hooks/useAdyenIsEnabled'
import { useAutoUpdatingRef } from '@quickmd-llc/frontend-utils'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const NewVisitListener = ({ bookingId, addCardSuccess, bookVisitSuccess }) => {
  const dispatch = useDispatch()

  const { adyenIsEnabled } = useAdyenIsEnabled()
  const adyenIsEnabledRef = useAutoUpdatingRef(adyenIsEnabled)
  useEffect(() => {
    const unsubscribe = dispatch(
      addListener({
        predicate: () => true,
        effect: async (action, listenerApi) => {
          switch (action.type) {
            case ADD_CREDIT_CARD_SUCCESS:
              // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
              if (action.extraData.bookingId === bookingId) {
                addCardSuccess()
                listenerApi.dispatch(
                  getPatientCreditCards(
                    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
                    action.extraData.patientId,
                    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
                    action.extraData.bookingId,
                    adyenIsEnabledRef.current,
                  ),
                )
              }
              break
            case BOOK_VISIT_SUCCESS:
              // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
              if (action.extraData.bookingId === bookingId) {
                bookVisitSuccess()
              }
              break
            case BOOK_VISIT_ERROR:
              if (
                // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
                action.extraData.bookingId === bookingId &&
                // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
                action.payload.ErrorCode === apiErrorCodes.CREDIT_CARD_NOT_FOUND
              ) {
                listenerApi.dispatch(
                  getPatientCreditCards(
                    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
                    action.extraData.patientId,
                    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
                    action.extraData.bookingId,
                    adyenIsEnabledRef.current,
                  ),
                )
              }
              break
            default:
              break
          }
        },
      }),
    )
    return () => {
      // @ts-expect-error TS2349 -- MIGRATION: not approved, fix when encountered
      if (unsubscribe) unsubscribe()
    }
  }, [])

  return null
}
